
import { baseUrl } from "../../constants";

export default {
    "formTitle": "Add Tag",
    "tableTitle": "Tag List",
    "apiDetails": {
        startUp: () => {
        },
        list: {
            url: `${baseUrl}/api/mms/tag/list`,
            payload: {
                "search": "",
                "offset": 0,
                "limit": 50,
                "sort": "DESC",
                "column": "id"
            }
        },
        add: `${baseUrl}/api/mms/tag`,
        edit: `${baseUrl}/api/mms/tag/edit`,
        delete: `${baseUrl}/api/mms/tag/remove`
    },
    "tableCol": [
        {
            name: 'Tag',
            selector: row => row.name,
            sortable: true
        }
    ],
    "formData": [
        {
            "formType": "flex",
            "formFields": [
                {
                    type: 'text',
                    label: 'Tag',
                    name: 'name',
                    "required": true
                }
            ]
        }
    ],
    "mockData": [{
        "name": "12"
    }]
}